module.exports = __webpack_public_path__ + "img/box3_img2_active_dark.6ec0ea51.png";